import { useListar } from "../../../../Services/Pessoa/EmpresaService";
import { SelectComPesquisa } from "../../../SelectComPesquisa";

export default function EmpresaSelect({
    ...props
}:any) {
    const {
        data,
        isLoading
    } = useListar({});

    return <SelectComPesquisa 
        {...props}
        placeholder={"Todos"}
        allowClear
        loading={isLoading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : (m.nomeSocial?.length ?? 0 > 0) ? m.nomeSocial : m.nome
            }
        })}
    />
}